export function PageLoader({ label }: { label: string }) {
  return (
    <div className="page-loader" role="status">
      <span className="loader-ring" aria-hidden="true" />
      <span>{label}</span>
    </div>
  )
}
